import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

export const useQueryLargestAddedActivitiesTableData = (params, endpoint?: string) => {
    return useQuery({
        queryKey: ['largestAddedActivitiesTableData', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
